// Extract a YouTube video id from any common URL form. Returns null if none.
export function extractYouTubeId(input) {
  if (!input) return null;
  const raw = input.trim();

  // Bare 11-char id
  if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return raw;

  let url;
  try {
    url = new URL(raw.startsWith("http") ? raw : `https://${raw}`);
  } catch {
    return null;
  }

  const host = url.hostname.replace(/^www\./, "").replace(/^m\./, "").replace(/^music\./, "");

  // youtu.be/<id>
  if (host === "youtu.be") {
    const id = url.pathname.split("/").filter(Boolean)[0];
    return isId(id) ? id : null;
  }

  if (host.endsWith("youtube.com") || host.endsWith("youtube-nocookie.com")) {
    // watch?v=<id>
    const v = url.searchParams.get("v");
    if (isId(v)) return v;
    // /embed/<id>, /shorts/<id>, /v/<id>, /live/<id>
    const parts = url.pathname.split("/").filter(Boolean);
    const idx = parts.findIndex((p) => ["embed", "shorts", "v", "live"].includes(p));
    if (idx >= 0 && isId(parts[idx + 1])) return parts[idx + 1];
  }

  return null;
}

function isId(id) {
  return !!id && /^[A-Za-z0-9_-]{11}$/.test(id);
}
